export default "__VITE_ASSET__cf17e293__"